package linkerpangoquipdb

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MaintenanceSparePartsQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> select_by_maintenance_id(maintenance_id: Long, mapper: (maintenance_id: Long, spare_part_id: Long) -> T): Query<T> = Select_by_maintenance_idQuery(maintenance_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!
    )
  }

  public fun select_by_maintenance_id(maintenance_id: Long): Query<Maintenance_spare_parts> = select_by_maintenance_id(maintenance_id, ::Maintenance_spare_parts)

  public fun <T : Any> select_by_spare_part_id(spare_part_id: Long, mapper: (maintenance_id: Long, spare_part_id: Long) -> T): Query<T> = Select_by_spare_part_idQuery(spare_part_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!
    )
  }

  public fun select_by_spare_part_id(spare_part_id: Long): Query<Maintenance_spare_parts> = select_by_spare_part_id(spare_part_id, ::Maintenance_spare_parts)

  public fun <T : Any> select_all(mapper: (maintenance_id: Long, spare_part_id: Long) -> T): Query<T> = Query(1_341_673_909, arrayOf("maintenance_spare_parts"), driver, "MaintenanceSpareParts.sq", "select_all", "SELECT maintenance_spare_parts.maintenance_id, maintenance_spare_parts.spare_part_id FROM maintenance_spare_parts") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!
    )
  }

  public fun select_all(): Query<Maintenance_spare_parts> = select_all(::Maintenance_spare_parts)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insert(maintenance_id: Long, spare_part_id: Long): Long {
    val result = driver.execute(759_207_952, """INSERT INTO maintenance_spare_parts (maintenance_id, spare_part_id) VALUES (?, ?)""", 2) {
          var parameterIndex = 0
          bindLong(parameterIndex++, maintenance_id)
          bindLong(parameterIndex++, spare_part_id)
        }.await()
    notifyQueries(759_207_952) { emit ->
      emit("maintenance_spare_parts")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_by_maintenance_id(maintenance_id: Long): Long {
    val result = driver.execute(86_299_314, """DELETE FROM maintenance_spare_parts WHERE maintenance_id = ?""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, maintenance_id)
        }.await()
    notifyQueries(86_299_314) { emit ->
      emit("maintenance_spare_parts")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_by_spare_part_id(spare_part_id: Long): Long {
    val result = driver.execute(-1_741_775_564, """DELETE FROM maintenance_spare_parts WHERE spare_part_id = ?""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, spare_part_id)
        }.await()
    notifyQueries(-1_741_775_564) { emit ->
      emit("maintenance_spare_parts")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_all(): Long {
    val result = driver.execute(467_251_940, """DELETE FROM maintenance_spare_parts""", 0).await()
    notifyQueries(467_251_940) { emit ->
      emit("maintenance_spare_parts")
    }
    return result
  }

  private inner class Select_by_maintenance_idQuery<out T : Any>(
    public val maintenance_id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("maintenance_spare_parts", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("maintenance_spare_parts", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(1_954_066_371, """SELECT maintenance_spare_parts.maintenance_id, maintenance_spare_parts.spare_part_id FROM maintenance_spare_parts WHERE maintenance_id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, maintenance_id)
    }

    override fun toString(): String = "MaintenanceSpareParts.sq:select_by_maintenance_id"
  }

  private inner class Select_by_spare_part_idQuery<out T : Any>(
    public val spare_part_id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("maintenance_spare_parts", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("maintenance_spare_parts", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-850_241_021, """SELECT maintenance_spare_parts.maintenance_id, maintenance_spare_parts.spare_part_id FROM maintenance_spare_parts WHERE spare_part_id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, spare_part_id)
    }

    override fun toString(): String = "MaintenanceSpareParts.sq:select_by_spare_part_id"
  }
}
